
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SingularityPanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import SectionCard from "@/components/Singularity/SingularitySectionLibraryModal/SectionCard.vue";
import { singularityStore, uiStore, documentStore } from "@/store/store";
import { findFirstChildOfElementBeingInlineEdited } from "@/lib/singularity/page-structure/api-for-global-block-inline-editing";
import { getSectionCardDataFromNode } from "@/lib/singularity/section-add-or-swap";
import PageStructureSectionColorsNew from "@/components/Singularity/PageStructure/PageStructureSectionColorsNew.vue";
import EditWithAiButton from "@/components/Singularity/components/EditWithAiButton.vue";
import { isHeaderInOverlayMode } from "@/futurelayer/headers-footers/overlay-headers";
import { findNode } from "@/lib/tree/tree";

@Component({
  components: {
    SingularityPanelHeader,
    NiceButton,
    SectionCard,
    PageStructureSectionColorsNew,
    EditWithAiButton
  }
})
export default class HeaderAndFooterEditor extends Vue {
  get elementId() {
    return singularityStore.headerAndFooterEditorPanelState?.elementId;
  }

  get sectionIdToOperateOn() {
    return findFirstChildOfElementBeingInlineEdited();
  }

  get sectionCardData() {
    return this.sectionIdToOperateOn
      ? getSectionCardDataFromNode(this.sectionIdToOperateOn)
      : null;
  }

  get elementType() {
    return singularityStore.headerAndFooterEditorPanelState?.elementType;
  }

  get uiStoreActiveElementId() {
    return uiStore.activeElementId;
  }

  get uiStoreInlineEditingContext() {
    return uiStore.inlineEditingContext;
  }

  get isHeader(): boolean {
    return this.elementType === "header";
  }

  get isOverlayHeader(): boolean {
    if (!this.isHeader || !this.elementId) return false;
    const headerElement = findNode(documentStore.document.tree, this.elementId);
    if (!headerElement) return false;
    return isHeaderInOverlayMode(headerElement);
  }

  editMenu() {
    singularityStore.setSingularityLeftPanel("page_manager");
  }

  editLogo() {
    singularityStore.setSingularityLeftPanel("brand");
  }

  replaceWithAnother() {
    if (!this.sectionIdToOperateOn) return;

    singularityStore.setSectionAddOrSwapPanelState({
      mode: "swap",
      sectionId: this.sectionIdToOperateOn
    });
    singularityStore.setSectionLibraryModalState(true);
  }

  mounted() {
    this.$watch("uiStoreActiveElementId", () => {
      const isHeaderFooterActive =
        this.elementId === this.uiStoreActiveElementId;
      const isChildSectionActive =
        this.sectionIdToOperateOn === this.uiStoreActiveElementId;

      if (!isHeaderFooterActive && !isChildSectionActive) {
        singularityStore.setHeaderAndFooterEditorPanelState(null);
      }
    });

    this.$watch("uiStoreInlineEditingContext", newContext => {
      if (!newContext || newContext.elementId !== this.elementId) {
        singularityStore.setHeaderAndFooterEditorPanelState(null);
      }
    });
  }
}
